import { EVENT_VIEW_PARENT_PRODUCTS } from '~~/constants/googleTagManager';
import type { ViewParentProducts, EcommerceViewParentProducts } from '~~/types/integrations/tagManager/TagViewParentProducts';

export const buildViewParentProductsTags = ({
  accessorySku,
  viewParentProductItems,
}: {
  accessorySku: string;
  viewParentProductItems: ViewParentProducts;
}) => ({
  event: EVENT_VIEW_PARENT_PRODUCTS,
  ecommerce: {
    detail: {
      accessory_id: accessorySku,
      items: viewParentProductItems,
    },
  } as EcommerceViewParentProducts,
});
